// ============================================
// API ENDPOINT CONSTANTS
// Ported from old/src/api/endpoints/endpoints.js
// DO NOT change these — must match backend exactly
// ============================================

export const API_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
} as const;

export type ApiMethod = (typeof API_METHOD)[keyof typeof API_METHOD];

export const AUTH = {
  USER_LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  SEND_OTP: '/auth/sendOtp',
  FORGOT_PASSWORD: '/auth/forgetPassword',
  VERIFY_OTP: '/auth/verifyOtp',
  CHANGE_PASSWORD: '/auth/changePassword',
  REFRESH_TOKENS: '/auth/refreshTokens',
};

export const ENTITY = {
  POST_ENTITY: '/entity',
  GET_ENTITY: '/entity',
  PUT_ENTITY: '/entity',
  DELETE_ENTITY: '/entity',
  GET_NESTED_ENTITY: '/entity/nested',
  GET_CHILDREN_BY_PARENTS: '/entity/getParentsOrChildrensOrCurrentById',
  SUBJECT_INDEX: '/subjectIndex',
  GET_SUBJECT_INDEX: '/subjectIndex',
  UPDATE_INDEX: '/subjectIndex',
  DELETE_INDEX: '/subjectIndex',
  UPLOAD_FILE: '/subjectIndex',
  SET_SEQ_INDEX_ENTITY: '/entity/updateSequenceNumber',
  ACADEMIC_CALENDAR: '/entityWiseCalendar',
  ACADEMIC_BULK_YEAR_ADD_CALENDAR: '/entityWiseCalendar/initialYears',
  UPDATE_STATUS_ACADEMIC: '/entityWiseCalendar/updateStatus',
};

export const ENTITY_TYPE = {
  POST_ENTITY_TYPE: '/entityType',
  GET_ENTITY_TYPE: '/entityType',
  PUT_ENTITY_TYPE: '/entityType',
  DELETE_ENTITY_TYPE: '/entityType',
};

export const MODULE = {
  GET_MODULE: '/module/default',
};

export const BANNER = {
  POST_BANNER: '/banner',
  GET_BANNER: '/banner',
  GET_BANNER_PAGINATION: '/banner/paginatedRecords',
  GET_BANNER_BY_ID: '/banner',
  PUT_BANNER_BY_ID: '/banner',
  DELETE_BANNER_BY_ID: '/banner',
};

export const COINPURCHASEOFFER = {
  POST_COIN_PURCHASE_OFFER: '/coinPurchaseOffer',
  GET_COIN_PURCHASE_OFFER: '/coinPurchaseOffer',
  GET_COIN_PURCHASE_OFFER_PAGINATION: '/coinPurchaseOffer/paginatedRecords',
  GET_COIN_PURCHASE_OFFER_BY_ID: '/coinPurchaseOffer',
  PUT_COIN_PURCHASE_OFFER_BY_ID: '/coinPurchaseOffer/:id',
  DELETE_COIN_PURCHASE_OFFER_BY_ID: '/coinPurchaseOffer/:id',
};

export const SUBSCRIPTIONPLAN = {
  POST_SUBSCRIPTION_PLAN: '/subscriptionPlan',
  GET_SUBSCRIPTION_PLAN: '/subscriptionPlan',
  GET_SUBSCRIPTION_PLAN_PAGINATION: '/subscriptionPlan/paginatedRecords',
  GET_SUBSCRIPTION_PLAN_BY_ID: '/subscriptionPlan',
  PUT_SUBSCRIPTION_PLAN_BY_ID: '/subscriptionPlan/:id',
  DELETE_SUBSCRIPTION_PLAN_BY_ID: '/subscriptionPlan/:id',
  UPDATE_SUBSCRIPTION_PLAN_SEQUENCE: '/subscriptionPlan/updateSequence',
  DASHBOARD: '/subscriptionPlan/dashboard/',
};

export const CLOUDSTORAGE = {
  POST_CLOUD_STORAGE: '/cloudStorage',
  GET_CLOUD_STORAGE: '/cloudStorage',
  GET_CLOUD_STORAGE_PAGINATION: '/cloudStorage/paginatedRecords',
  GET_CLOUD_STORAGE_BY_ID: '/cloudStorage',
  PUT_CLOUD_STORAGE_BY_ID: '/cloudStorage',
  DELETE_CLOUD_STORAGE_BY_ID: '/cloudStorage',
};

export const REPORTCOLUMNLIST = {
  POST_REPORT_COLUMN_LIST: '/columnList',
  GET_REPORT_COLUMN_LIST: '/columnList',
  GET_REPORT_COLUMN_LIST_PAGINATION: '/columnList/paginatedRecords',
  PUT_REPORT_COLUMN_LIST_BY_ID: '/columnList',
  DELETE_REPORT_COLUMN_LIST_BY_ID: '/columnList',
};

export const COURSE = {
  POST_COURSE: '/course',
  GET_COURSE: '/course',
  GET_COURSE_PAGINATION: '/course/paginatedRecords',
  PUT_COURSE_BY_ID: '/course',
  DELETE_COURSE_BY_ID: '/course',
};

export const FILESTORAGE = {
  POST_FILE_STORAGE: '/fileStorage',
  GET_FILE_STORAGE_BY_ID: '/fileStorage',
  PUBLIC_FILES: '/fileStorage/public',
};

export const APK_MANAGEMENT = {
  UPLOAD_APK: '/fileStorage/apk',
  GET_APKS: '/fileStorage/apk',
};

export const ANNOUNCEMENT = {
  CREATE_ANNOUNCEMENT: '/announcement',
  GET_ALL_ANNOUNCEMENT: '/announcement',
  GET_ALL_ANNOUNCEMENT_PAGINATION: '/announcement/paginatedRecords',
  GET_ANNOUNCEMENT_BY_ID: '/announcement',
  EDIT_ANNOUNCEMENT: '/announcement',
  DELETE_ANNOUNCEMENT: '/announcement',
  GOVT_ANNOUNCEMENT: '/announcement/govtAnnouncement',
  GOVT_ANNOUNCEMENT_PAGINATION: '/announcement/govtAnnouncement/paginatedRecords',
};

export const BATCHANDSUBJECT = {
  POST_BATCH_AND_SUBJECT: '/batch',
  GET_BATCH_AND_SUBJECT: '/batch',
  GET_BATCH_AND_SUBJECT_BY_ID: '/batch',
  PUT_BATCH_AND_SUBJECT_BY_ID: '/batch',
  DELETE_BATCH_AND_SUBJECT_BY_ID: '/batch',
  GET_USER_BY_BATCH: '/batch/getUsersByBatch',
  GET_BATCH_BY_USER: '/batch/getAssignedBatchesByUserAndInstitiute',
};

export const ADVERTISEMENT = {
  POST: '/advertisement',
  GET_PAGINATION: '/advertisement/paginatedRecords',
  PUT: '/advertisement',
  DELETE: '/advertisement',
};

export const ROLE = {
  POST_ROLE: '/role',
  GET_ROLE: '/role',
  GET_ROLE_BY_ID: '/role',
  PUT_ROLE_BY_ID: '/role',
  PUT_ADMINISTRATIVE_ROLE_BY_ID: '/role/assignRole',
  DELETE_ROLE_BY_ID: '/role',
};

export const DEFAULT_MODULE = {
  GET_DEFAULT_MODULE: '/module/default',
};

export const TICKET = {
  GET_TICKET: '/ticketRaise',
  POST_TICKET: '/ticketRaise',
  GET_TICKET_PAGINATION: '/ticketRaise/paginatedRecords',
  PUT_TICKET: '/ticketRaise',
  DELETE_TICKET: '/ticketRaise',
  POST_CONVERSATION: '/ticketRaise/conversation',
  POST_CONVERSATION_DELETE: '/ticketRaise/conversationDelete',
};

export const SUBADMINS = {
  DELETE_USER_META: '/user',
  GET_USER_META: '/user/paginatedRecords',
  PUT_USER: '/user',
  POST_USER: '/user',
  ASSIGN_ROLE: '/role/assignRole',
  UPDATE_ROLE: '/role/assignRole',
  GET_USER_ROLE: '/role/getRoleAndPermissionsByUser',
  CHANGE_PASSWORD_EMAIL: '/user/changePasswordEmail',
};

export const TYPEMANAGEMENT = {
  POST_TYPEMANAGEMENT: '/typeManagement',
  GET_TYPEMANAGEMENT: '/typeManagement',
  GET_TYPEMANAGEMENT_BY_ID: '/typeManagement',
  PUT_TYPEMANAGEMENT_BY_ID: '/typeManagement',
  DELETE_TYPEMANAGEMENT_BY_ID: '/typeManagement',
};

export const CERTIFICATEMANAGEMENT = {
  POST_CERTIFICATE_MANAGEMENT: '/certificatesManagement',
  GET_CERTIFICATE_MANAGEMENT: '/certificatesManagement',
  GET_CERTIFICATE_MANAGEMENT_BY_ID: '/certificatesManagement',
  PUT_CERTIFICATE_MANAGEMENT_BY_ID: '/certificatesManagement',
  DELETE_CERTIFICATE_MANAGEMENT_BY_ID: '/certificatesManagement',
};

export const INSTITUTE_LIST = {
  GET_INSTITUTE_LIST: '/institute',
  GET_STUDENT_LIST: '/userInstituteMeta',
  GET_TEACHER_LIST: '/userInstituteMeta',
  UPDATE_INSTITUTE: '/institute/basicDetails',
  GET_INSTITUTE_LIST_PAGINATION: '/institute/paginatedRecords',
  GET_STUDENT_LIST_PAGINATION: '/userInstituteMeta/paginatedRecords',
  GET_TEACHER_LIST_PAGINATION: '/userInstituteMeta/paginatedRecords',
  FORCE_FULLY_ADD_DATA: '/institute/forceFullyAddData',
  FORCEFULLY_DELETE_INSTITUTE: '/userInstituteMeta/forcefullyDeleteInstitute',
  GET_USER_PAGINATION: '/user/paginatedRecords',
  ACADEMIC_CALENDAR_LIST: '/academicCalendar',
  GET_INSTITUTE_ENTITY: '/userInstituteMeta/getByIntituteAndUser',
  OWNERSHIP_HISTORY: '/instituteOwnershipHistory',
};

export const DASHBOARD = {
  DASHBOARD: '/admin/adminDashboard',
  USAGE_COUNT: '/subscriptionPlan/usageCountWithDetails',
};

export const SAMPLEFILEUPLOAD = {
  CREATE_SAMPLE_FILES: '/fileStorage/upload-overwrite',
  GET_SAMPLE_FILES: '/fileStorage/get-file',
};

export const INFORMATION = {
  CREATE_INFORMATION: '/informationSupport',
  GET_INFORMATION: '/informationSupport/paginatedRecords',
  DELETE_INFORMATION: '/informationSupport',
};

export const SHEET_FIELD = {
  CREATE_SHEET_FIELD: '/sheetField',
  BULK_UPSERT_SHEET_FIELD: '/sheetField/bulkUpsert',
  GET_SHEET_FIELD: '/sheetField',
  GET_SHEET_FIELD_BY_ID: '/sheetField',
  UPDATE_SHEET_FIELD: '/sheetField',
  DELETE_SHEET_FIELD: '/sheetField',
};

export const EDUCATION_OFFICER = {
  POST_EDUCATION_OFFICER: '/educationOfficer',
  GET_EDUCATION_OFFICER_PAGINATION: '/educationOfficer/paginatedRecords',
  UPDATE_EDUCATION_OFFICER: '/educationOfficer',
  DELETE_EDUCATION_OFFICER: '/educationOfficer',
};

export const DEO_COLLECTION = {
  USER: '/deoCollection/user',
  GET_USER_PAGINATION: '/user/paginatedRecords',
  FORCE_FULLY_ADD_DATA: '/deoCollection/forceFullyAddData',
};

export const LOCATION = {
  GET_COUNTRY: '/country',
};

export const MAINTENANCE = {
  GET_MAINTENANCE: '/maintenance',
  POST_MAINTENANCE: '/maintenance/bulk',
  PUT_MAINTENANCE: '/maintenance',
  DELETE_MAINTENANCE: '/maintenance',
};

export const ARENA = {
  SPORTS: '/arena/sports',
  SPORT_CATEGORIES: '/arena/sportCategories',
  SPORT_SUB_CATEGORIES: '/arena/sportSubCategories',
  SPORT_ROLES: '/arena/sportRoles',
  EQUIPMENTS: '/arena/equipments',
  FACILITY_MASTERS: '/arena/facilityMasters',
  UNITS: '/arena/units',
  SKILLS: '/arena/skills',
  AGE_GROUPS: '/arena/ageGroups',
  SPORT_GROUP_DATA: '/arena/sportGroupData',
  SPORT_GROUP_DATA_SYNC: '/arena/sportGroupData/sync',
  SPORT_GROUP_DATA_SYNC_BY_FACILITY: '/arena/sportGroupData/syncByFacility',
  SPORT_GROUP_DATA_SYNC_BY_EQUIPMENT: '/arena/sportGroupData/syncByEquipment',
  SPORT_GROUP_DATA_SYNC_BY_AMENITY: '/arena/sportGroupData/syncByAmenity',
  SPORT_GROUP_DATA_BY_FACILITY: '/arena/sportGroupData/byFacility',
  SPORT_GROUP_DATA_BY_EQUIPMENT: '/arena/sportGroupData/byEquipment',
  SPORT_GROUP_DATA_BY_AMENITY: '/arena/sportGroupData/byAmenity',
  ASSESSMENT_TESTS: '/arena/assessmentTests',
  SPORT_INFOS: '/arena/sportInfos',
  SPORTS_ACADEMIES: '/arena/sportsAcademies',
  SPORTS_ACADEMIES_PAGINATION: '/arena/sportsAcademies/paginatedRecords',
  USER_ACADEMY_META: '/arena/userAcademyMeta',
  USER_ACADEMY_META_PAGINATION: '/arena/userAcademyMeta/paginatedRecords',
  USER_AMENITIES: '/arena/userAmenities',
  USER_AMENITIES_PAGINATION: '/arena/userAmenities/paginatedRecords',
  ANNOUNCEMENTS: '/arena/announcements',
  ANNOUNCEMENTS_PAGINATION: '/arena/announcements/paginatedRecords',
};

export const VENDOR = {
  ANNOUNCEMENTS: '/vendor/announcements',
  ANNOUNCEMENTS_PAGINATION: '/vendor/announcements/paginatedRecords',
};

export const SUBSCRIPTION_CONFIGURATION = {
  POST_SUBSCRIPTION_CONFIGURATION: '/subscriptionConfiguration',
  GET_SUBSCRIPTION_CONFIGURATION: '/subscriptionConfiguration',
  PUT_SUBSCRIPTION_CONFIGURATION: '/subscriptionConfiguration',
  DELETE_SUBSCRIPTION_CONFIGURATION: '/subscriptionConfiguration',
};

export const MODULE_PRICE = {
  CREATE: '/modulePrice',
  GET_ALL_PAGINATED: '/modulePrice/paginatedRecords',
  UPDATE: '/modulePrice/:id',
  DELETE: '/modulePrice/:id',
};

export const TERMS_AND_CONDITION = {
  POST_TERMS_AND_CONDITION: '/termsAndCondition',
  GET_TERMS_AND_CONDITION: '/termsAndCondition',
  GET_TERMS_AND_CONDITION_PAGINATION: '/termsAndCondition',
  GET_TERMS_AND_CONDITION_BY_ID: '/termsAndCondition',
  PUT_TERMS_AND_CONDITION_BY_ID: '/termsAndCondition',
  DELETE_TERMS_AND_CONDITION_BY_ID: '/termsAndCondition',
};

export const WALLET = {
  TRANSACTION: '/walletTransaction',
  GET_WALLET: '/wallet',
};

export const WALLET_HISTORY = {
  GET_PAGINATED: '/walletHistory/paginatedRecords',
};

export const INSTITUTE_SUBSCRIPTION = {
  GET_PLAN: '/instituteSubscriptionPlan',
};

export const ANALYTICS = {
  DASHBOARD: '/appAnalyticsEvent/admin/dashboard',
  GENERAL: '/appAnalyticsEvent/admin/dashboard',
  ENGAGEMENT: '/appAnalyticsEvent/admin/engagement',
  VERSIONS: '/appAnalyticsEvent/admin/versions',
  PATTERNS: '/appAnalyticsEvent/admin/patterns',
  USER_LIFECYCLE: (userId: string) => `/appAnalyticsEvent/admin/user-lifecycle/${userId}`,
};

export const COMMUNITY_GROUP = {
  POST: '/communityGroup',
  GET: '/communityGroup',
  PUT: '/communityGroup',
  DELETE: '/communityGroup',
};

export const DESIGNATION = {
  GET: '/designation',
};

export const MASTER_DESIGNATION = {
  GET: '/masterDesignation',
  POST: '/masterDesignation',
  PUT: '/masterDesignation',
  DELETE: (id: string) => `/masterDesignation/${id}`,
  BULK_UPSERT: '/masterDesignation/bulkUpsert',
};

export const PERMISSIONS = {
  LIST: '/permissions',
  UPSERT: '/permissions/upsert',
  DELETE: '/permissions',
  UPDATE_SEQUENCE: '/permissions/sequence',
  EXPORT: '/permissions',
  IMPORT_JSON: '/permissions/uploadJson',
};

export const ROLE_MANAGEMENT = {
  LIST: '/roleManagement',
  UPSERT: '/roleManagement',
  DETAIL: (id: string) => `/roleManagement/${id}`,
  DELETE: (id: string) => `/roleManagement/${id}`,
};

export const MODULE_DOC_AI = {
  POST_MODULE_DOC: '/moduleDocs',
  GET_MODULE_DOC: '/moduleDocs',
  PUT_MODULE_DOC: '/moduleDocs',
  DELETE_MODULE_DOC: '/moduleDocs',
};

export const TEPDS_EVALUATION_CATEGORY = {
  PAGINATED_RECORDS: '/tepds/evaluationCategories/paginatedRecords',
  GET_ALL: '/tepds/evaluationCategories',
  GET_LIST: '/tepds/evaluationCategories/getList',
  GET_BY_ID: (id: string) => `/tepds/evaluationCategories/${id}`,
  CREATE: '/tepds/evaluationCategories',
  UPDATE: (id: string) => `/tepds/evaluationCategories/${id}`,
  DELETE: (id: string) => `/tepds/evaluationCategories/${id}`,
};

export const TEPDS_RATING_SCALE = {
  PAGINATED_RECORDS: '/tepds/ratingScales/paginatedRecords',
  GET_ALL: '/tepds/ratingScales',
  GET_LIST: '/tepds/ratingScales/getList',
  GET_BY_ID: (id: string) => `/tepds/ratingScales/${id}`,
  CREATE: '/tepds/ratingScales',
  UPDATE: (id: string) => `/tepds/ratingScales/${id}`,
  DELETE: (id: string) => `/tepds/ratingScales/${id}`,
};

export const TEPDS_EVALUATION_TEMPLATE = {
  PAGINATED_RECORDS: '/tepds/evaluationTemplates/paginatedRecords',
  GET_ALL: '/tepds/evaluationTemplates',
  GET_LIST: '/tepds/evaluationTemplates/getList',
  GET_BY_ID: (id: string) => `/tepds/evaluationTemplates/${id}`,
  CREATE: '/tepds/evaluationTemplates',
  UPDATE: (id: string) => `/tepds/evaluationTemplates/${id}`,
  DELETE: (id: string) => `/tepds/evaluationTemplates/${id}`,
  PUBLISH: (id: string) => `/tepds/evaluationTemplates/${id}/publish`,
};

export const TEPDS_EVALUATION_TEMPLATE_SECTION = {
  PAGINATED_RECORDS: '/tepds/evaluationTemplateSections/paginatedRecords',
  GET_ALL: '/tepds/evaluationTemplateSections',
  GET_LIST: '/tepds/evaluationTemplateSections/getList',
  GET_BY_ID: (id: string) => `/tepds/evaluationTemplateSections/${id}`,
  CREATE: '/tepds/evaluationTemplateSections',
  UPDATE: (id: string) => `/tepds/evaluationTemplateSections/${id}`,
  DELETE: (id: string) => `/tepds/evaluationTemplateSections/${id}`,
};

export const TEPDS_EVALUATION_TEMPLATE_QUESTION = {
  PAGINATED_RECORDS: '/tepds/evaluationTemplateQuestions/paginatedRecords',
  GET_ALL: '/tepds/evaluationTemplateQuestions',
  GET_LIST: '/tepds/evaluationTemplateQuestions/getList',
  GET_BY_ID: (id: string) => `/tepds/evaluationTemplateQuestions/${id}`,
  CREATE: '/tepds/evaluationTemplateQuestions',
  UPDATE: (id: string) => `/tepds/evaluationTemplateQuestions/${id}`,
  DELETE: (id: string) => `/tepds/evaluationTemplateQuestions/${id}`,
};

export const TEPDS_EVALUATION_TEMPLATE_DESIGNATION_MAP = {
  PAGINATED_RECORDS: '/tepds/evaluationTemplateDesignationMaps/paginatedRecords',
  GET_ALL: '/tepds/evaluationTemplateDesignationMaps',
  GET_LIST: '/tepds/evaluationTemplateDesignationMaps/getList',
  GET_BY_ID: (id: string) => `/tepds/evaluationTemplateDesignationMaps/${id}`,
  CREATE: '/tepds/evaluationTemplateDesignationMaps',
  UPDATE: (id: string) => `/tepds/evaluationTemplateDesignationMaps/${id}`,
  DELETE: (id: string) => `/tepds/evaluationTemplateDesignationMaps/${id}`,
};

export const TEPDS_EVALUATION_WEIGHT_CONFIGURATION = {
  PAGINATED_RECORDS: '/tepds/evaluationWeightConfigurations/paginatedRecords',
  GET_ALL: '/tepds/evaluationWeightConfigurations',
  GET_LIST: '/tepds/evaluationWeightConfigurations/getList',
  BULK_UPSERT: '/tepds/evaluationWeightConfigurations/bulkUpsert',
  GET_BY_ID: (id: string) => `/tepds/evaluationWeightConfigurations/${id}`,
  CREATE: '/tepds/evaluationWeightConfigurations',
  UPDATE: (id: string) => `/tepds/evaluationWeightConfigurations/${id}`,
  DELETE: (id: string) => `/tepds/evaluationWeightConfigurations/${id}`,
};

export const MASTER_SETTING = {
  POST_MASTER_SETTING: '/masterSetting',
  GET_MASTER_SETTING: '/masterSetting',
  GET_MASTER_SETTING_PAGINATION: '/masterSetting/paginatedRecords',
  GET_MASTER_SETTING_BY_ID: '/masterSetting',
  PUT_MASTER_SETTING_BY_ID: '/masterSetting',
  DELETE_MASTER_SETTING_BY_ID: '/masterSetting',
  REGENERATE_PASSWORD: '/masterSetting/regenerate-password',
};

export const FRC_DOCS = {
  CREATE: '/frcDocs',
  GET_ALL: '/frcDocs',
  GET_LIST: '/frcDocs/getList',
  PAGINATED_RECORDS: '/frcDocs/paginatedRecords',
  GET_BY_ID: (id: string) => `/frcDocs/${id}`,
  UPDATE: (id: string) => `/frcDocs/${id}`,
  UPDATE_SEQUENCE: '/frcDocs/updateSequence',
  DELETE: (id: string) => `/frcDocs/${id}`,
};

export const ADMISSIONS_AGENCY = {
  PAGINATED_RECORDS: '/admissionsAgency/paginatedRecords',
  GET_BY_ID: (id: string) => `/admissionsAgency/${id}`,
  UPDATE: (id: string) => `/admissionsAgency/${id}`,
  UPDATE_STATUS: (id: string) => `/admissionsAgency/${id}`,
};

export const EXPO = {
  BASE: '/expo',
  POST_EXPO: '/expo',
  GET_ALL: '/expo',
  PAGINATED_RECORDS: '/expo/paginatedRecords',
  GET_LIST: '/expo/getList',
  GET_BY_ID: (id: string) => `/expo/${id}`,
  PUT_BY_ID: (id: string) => `/expo/${id}`,
  DELETE_BY_ID: (id: string) => `/expo/${id}`,
  EXPO_STAFF_ADD: '/expo/expoStaffAdd',
  USER_EXPO_META: '/userExpoMeta',
  USER_EXPO_META_BY_ID: (id: string) => `/userExpoMeta/${id}`,
};

export const EXPO_GRID = {
  BASE: '/expoGrid',
  CREATE: '/expoGrid',
  GET_ALL: '/expoGrid',
  GET_BY_ID: (id: string) => `/expoGrid/${id}`,
  UPDATE: (id: string) => `/expoGrid/${id}`,
  DELETE: (id: string) => `/expoGrid/${id}`,
  GENERATE_GRID: '/expoGrid/generateGrid',
  UPSERT: '/expoGrid/upsert',
  PAGINATED_RECORDS: '/expoGrid/paginatedRecords',
};

export const EXPO_STALL = {
  BASE: '/expoStall',
  CREATE: '/expoStall',
  GET_ALL: '/expoStall',
  GET_BY_ID: (id: string) => `/expoStall/${id}`,
  UPDATE: (id: string) => `/expoStall/${id}`,
  DELETE: (id: string) => `/expoStall/${id}`,
  GENERATE_GRID: '/expoStall/generateGrid',
  UPSERT: '/expoStall/upsert',
  PAGINATED_RECORDS: '/expoStall/paginatedRecords',
};

export const EXPO_REGISTRATION = {
  BASE: '/expoRegistration',
  GET_ALL: '/expoRegistration',
  GET_BY_ID: (id: string) => `/expoRegistration/${id}`,
};

export const EXPO_STAGE_SLOT = {
  BASE: '/expoStageSlot',
  CREATE: '/expoStageSlot',
  GET_ALL: '/expoStageSlot',
  GET_BY_ID: (id: string) => `/expoStageSlot/${id}`,
  UPDATE: (id: string) => `/expoStageSlot/${id}`,
  VERIFY: (id: string) => `/expoStageSlot/${id}/verify`,
  DELETE: (id: string) => `/expoStageSlot/${id}`,
  PAGINATED_RECORDS: '/expoStageSlot/paginatedRecords',
};

export const THEME = {
  BASE: '/theme',
  CREATE: '/theme',
  PAGINATED_RECORDS: '/theme/paginatedRecords',
  GET_ALL: '/theme',
  GET_BY_ID: (id: string) => `/theme/${id}`,
  UPDATE_BY_ID: (id: string) => `/theme/${id}`,
  DELETE_BY_ID: (id: string) => `/theme/${id}`,
};

export const HOSPITAL = {
  BASE: '/hospital',
  PAGINATED_RECORDS: '/hospital/paginatedRecords',
  PAGINATION_RECORD: '/hospital/paginatedRecords',
  PAGINATION_RECORDS: '/hospital/paginatedRecords',
  FORCE_FULLY_ADD_DATA: '/hospital/forceFullyAddData',
  GET_BY_ID: (id: string) => `/hospital/${id}`,
  UPDATE: (id: string) => `/hospital/${id}`,
};

export const QA_CONFIG = {
  QUESTION_SOURCE: {
    BASE: '/questionSources',
    PAGINATED: '/questionSources/paginatedRecords',
    BY_ID: (id: string) => `/questionSources/${id}`,
  },
  ANSWER_SOURCE: {
    BASE: '/answerSources',
    PAGINATED: '/answerSources/paginatedRecords',
    BY_ID: (id: string) => `/answerSources/${id}`,
  },
  QUESTION_TYPE: {
    BASE: '/questionType',
    PAGINATED: '/questionType/paginatedRecords',
    GET_LIST: '/questionType/getList',
    BY_ID: (id: string) => `/questionType/${id}`,
  },
  QUESTION_DIFFICULTY_LEVEL: {
    BASE: '/questionDifficultyLevel',
    PAGINATED: '/questionDifficultyLevel/paginatedRecords',
    GET_LIST: '/questionDifficultyLevel/getList',
    BY_ID: (id: string) => `/questionDifficultyLevel/${id}`,
  },
  QUESTION_COGNITIVE_LEVEL: {
    BASE: '/questionCognitiveLevel',
    PAGINATED: '/questionCognitiveLevel/paginatedRecords',
    GET_LIST: '/questionCognitiveLevel/getList',
    BY_ID: (id: string) => `/questionCognitiveLevel/${id}`,
  },
};